import { type FC } from "react";
import { Box, IconButton, Slider } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import { playerFooterControlPadding } from "./playerFooterControlPadding";

interface VolumeControlProps {
  volume: number;
  muted: boolean;
  onToggleMute: () => void;
  onSetVolume: (volume: number) => void;
}

export const VolumeControl: FC<VolumeControlProps> = ({
  volume,
  muted,
  onToggleMute,
  onSetVolume,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      "&:hover .volume-slider, &:focus-within .volume-slider": {
        width: 50,
        ml: 1,
      },
    }}
  >
    <IconButton
      size="large"
      onClick={onToggleMute}
      sx={(theme) => ({ color: "#fff", ...playerFooterControlPadding(theme) })}
    >
      {muted || volume === 0 ? <VolumeOffIcon /> : <VolumeUpIcon />}
    </IconButton>
    {/* Reference MuteButton never renders the slider while muted (only the
        button remains) — mirror that instead of leaving it collapsed-but-
        interactive underneath. */}
    {!muted && (
      <Box
        className="volume-slider"
        sx={{
          width: 0,
          overflow: "hidden",
          transition: "width 0.2s",
          "@media (max-width: 450px)": { display: "none" },
        }}
      >
        <Slider
          size="small"
          value={volume}
          min={0}
          max={1}
          step={0.01}
          onChange={(_event, value) => onSetVolume(value as number)}
          sx={{ color: "#fff" }}
        />
      </Box>
    )}
  </Box>
);
